import type { SVGProps } from "react";

const SvgBankhausSchelhammerSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="48.0 42.3 415.9 427.3"
    fill="none"
    {...props}
  >
    <path
      fill="#1a47ed"
      d="M102.4 210.368c0-7.863 3.802-15.205 10.133-19.566l130.845-90.141c7.643-5.266 17.601-5.266 25.244 0l130.845 90.141c6.33 4.361 10.133 11.703 10.133 19.566v16.809c0 6.494-5.095 11.757-11.378 11.757H113.778c-6.284 0-11.378-5.263-11.378-11.757z"
    />
    <path
      fill="#e6eaf4"
      d="M284.439 176.356c0 15.709-12.735 28.444-28.444 28.444-15.71 0-28.446-12.735-28.446-28.444 0-15.71 12.736-28.444 28.446-28.444 15.709 0 28.444 12.734 28.444 28.444"
    />
    <path
      fill="#1a47ed"
      d="M102.4 375.466c0-6.283 5.094-11.376 11.378-11.376h284.444c6.283 0 11.378 5.093 11.378 11.376v28.446c0 6.283-5.095 11.378-11.378 11.378H113.778c-6.284 0-11.378-5.095-11.378-11.378z"
    />
    <g fill="#1036c1">
      <path d="M125.15 238.934h56.889v125.155H125.15zM227.549 238.934h56.89v125.155h-56.89zM329.949 238.934h56.89v125.155h-56.89z" />
    </g>
  </svg>
);
export default SvgBankhausSchelhammerSmallLogo;
